import styles from './NavBack.module.css'

interface NavBackProps {
  label?: string
  onClick: () => void
}

export default function NavBack({ label = 'All Topics', onClick }: NavBackProps) {
  return (
    <button className={styles.navBack} onClick={onClick} data-testid="nav-back">
      <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="15 18 9 12 15 6" />
      </svg>
      {label}
    </button>
  )
}
